import { useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Img } from "./Img";

const MobileMenu = ({ isOpen, onClose }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleMenuClick = (e, id) => {
    e.preventDefault(); // 기본 링크 동작 방지
    const targetElement = document.querySelector(id);

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    setTimeout(() => {
      onClose(); // 이동 후 모달 닫기
    }, 300); // 부드러운 전환을 위해 약간의 지연 추가
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 top-0 left-0 right-0 w-full bg-black/50 backdrop-blur-xl z-[10000]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          ref={modalRef}
          className="bg-opacity-80 w-[100%] h-auto p-6 shadow-lg relative"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.8, opacity: 0 }}
        >
          {/* 닫기 버튼 */}
          <button className="absolute top-4 right-4 flex items-center justify-center self-end" onClick={onClose}>
            <Img src="images/menu-close.png" />
          </button>

          {/* 모달 내용 */}
          <div className="flex flex-col items-start gap-4 mt-10 pl-[11px]">
            <nav className="flex flex-col gap-6 text-white text-[36px] mt-[80px]">
              <a href="#About" className="hover:text-gray-300" onClick={(e) => handleMenuClick(e, "#About")}>About</a>
              <a href="#Programs" className="hover:text-gray-300" onClick={(e) => handleMenuClick(e, "#Programs")}>Programs</a>
              <a href="#Sponsors" className="hover:text-gray-300" onClick={(e) => handleMenuClick(e, "#Sponsors")}>Sponsors</a>
              <a href="https://secure.touchnet.net/C20832_ustores/web/store_main.jsp?STOREID=178&SINGLESTORE=true" className="hover:text-gray-300">Tickets</a>
              <a href="https://www.harvardxr.com/" className="hover:text-gray-300">HarvardXR 2024</a>
            </nav>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default MobileMenu;
